var nextID = 1;

export default function generateID() {
  return nextID++;
}

function maxFromList(list) {
  if (!list || list.length === 0) {
    return 0;
  } else {
    return Math.max.apply(this, list.map((o) => o.id)) + 1;
  }
}


export const setNextID = function(qdd) {
  nextID = Math.max.apply(this, ['categories', 'targets', 'questions', 'tags', 'translationList'].map((k) => maxFromList(qdd[k]))) + 1;
}
